import { JsonProperty, Serializable } from "typescript-json-serializer";
import { Vat } from "./vat";
@Serializable()
export class Vats{
    @JsonProperty({ type: Vat })
    vats:Array<Vat>
}